export const skillsData = [{
    id: 1,
    name: "Programming Languages",
    data: ["C#", "Javascript", "Typescript"],
    cardImage: "./assets/icons/language.svg",
  },
  {
    id: 2,
    name: "Markup Languages",
    data: ["Html", "Css", "Markdown"],
    cardImage: "./assets/icons/markup.svg",
  },
  {
    id: 3,
    name: "Libraries",
    data: ["React", "React Query", "React Router", "Material UI", "Ant Design", "Jquery"],
    cardImage: "./assets/icons/library.svg",
  },
  {
    id: 4,
    name: "Web Frameworks",
    data: ["ASP.NET Core", "Angular", "Bootstrap"],
    cardImage: "./assets/icons/framework.svg",
  },
  {
    id: 5,
    name: "Database",
    data: ["MS SQL Server, T-SQL"],
    cardImage: "./assets/icons/database.svg",
  },
  {
    id: 6,
    name: "Version Control System",
    data: ["Git/Github"],
    cardImage: "./assets/icons/version-control.svg",
  },
  {
    id: 7,
    name: "Package Manager",
    data: ["Npm", "Yarn"],
    cardImage: "./assets/icons/package-manager.svg",
  },
  {
    id: 8,
    name: "Code Editor / IDE",
    data: ["Visual Studio", "Visual Studio Code", "SQL Server Management System"],
    cardImage: "./assets/icons/code-editor.svg",
  },
];